import React from 'react'
import { zedPlayerPlay } from '~/player/actions'
import { useDispatch } from 'react-redux'

const ZD = () => {
  const dispatch = useDispatch()

  const playZD = (e) => {
    //const ondemandSrc = '//barry.4zzz.org.au:8001/zd.nsv'
    const playSrc = 'https://iheart.4zzz.org.au/zed-digital'
    dispatch(zedPlayerPlay({type: 'audio/mp3', src: playSrc}))

  //   var zedPlayer = videojs('zed-live')
  //   if(!zedPlayer.paused()){
  //     zedPlayer.pause()
  //   }
  //   zedPlayer.src({type: 'audio/mp3', src: ondemandSrc})
  //   //zedPlayer.tech_.el_.children[0].src = ondemandSrc
  //   zedPlayer.play()
  }


  return <a className="playzd" onClick={playZD}><img src="/assets/playzd.svg" alt="Stream ZD" /></a>
  
}
export default ZD
